import { Pipe, PipeTransform } from '@angular/core';
import { AdminRole } from '../services/users.service'

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case AdminRole[AdminRole.SuperAdmin]:
        return "超級管理員"
      case AdminRole[AdminRole.BrandAdmin]:
        return "品牌管理員"
      case AdminRole[AdminRole.StoreAdmin]:
        return "商店管理員"
      case AdminRole[AdminRole.StoreStaff]:
        return "一般員工"
      default:
        return "未知"
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/role.pipe.ts